import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit, businessDetails } from '@/api/yuntuSales/chanceManage'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'

const __default__ = { name: 'DcCosLbuBusinessEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const initForm: LbuBusinessEditParams = ref({})
const dataForm = ref<LbuBusinessEditParams>({})
const originalStatus = ref<number>()
onBeforeMount(() => {
  businessDetails({ id: route.query.id }).then((res) => {
    if (!res.data.failedCooperateId) {
      res.data.failedCooperateId = undefined
    }
    if (!res.data.assistDepartment) {
      res.data.assistDepartment = undefined
    }
    originalStatus.value = res.data.status
    dataForm.value = res.data
    initForm.value = cloneDeep(res.data)
  })
})

const fetch = (val: any) => {
  dataForm.value = val
}
const businessFormRef = ref()
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(() => {
    const { status } = dataForm.value

    if (status === 4 || status === 9) {
      const { oprWeight, ocrWeight, oprCube, ocrCube } = dataForm.value
      if (oprWeight && !ocrWeight) {
        message.error('请输入OCR重量')
        return
      } else if (oprCube && !ocrCube) {
        message.error('请输入OCR方数')
        return
      }
    }

    loading.value = true
    const params = dataForm.value
    businessCreateOrEdit(params)
      .then(() => {
        message.success('编辑成功')
        businessFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(CosLayoutMain, null, {
    content: _withCtx(() => [
      _createVNode(BusinessForm, {
        ref_key: "businessFormRef",
        ref: businessFormRef,
        title: "编辑商机",
        type: "edit",
        value: dataForm.value,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((dataForm).value = $event)),
          fetch
        ],
        originalStatus: originalStatus.value
      }, null, 8, ["value", "originalStatus"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_cos_footer_button, {
        loading: loading.value,
        value: dataForm.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm).value = $event)),
        hideOk: "",
        disabled: false,
        resetValue: initForm.value
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          })), [
            [_directive_permission, 'lbu_business_edit_btn']
          ])
        ]),
        _: 1
      }, 8, ["loading", "value", "resetValue"])
    ]),
    _: 1
  }))
}
}

})